import { render, staticRenderFns } from "./LandingPageModal.vue?vue&type=template&id=fd0c86a2&scoped=true&"
import script from "./LandingPageModal.vue?vue&type=script&lang=js&"
export * from "./LandingPageModal.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageModal.vue?vue&type=style&index=0&id=fd0c86a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0c86a2",
  null
  
)

export default component.exports